import { render, staticRenderFns } from "./approver_config.vue?vue&type=template&id=31d5860f&scoped=true"
import script from "./approver_config.vue?vue&type=script&lang=js"
export * from "./approver_config.vue?vue&type=script&lang=js"
import style0 from "./approver_config.vue?vue&type=style&index=0&id=31d5860f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d5860f",
  null
  
)

export default component.exports